var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"broker-presentation-view"},[_c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('presentation-table')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }